package ru.education.building.schedule.view.httpclient

import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import ru.education.building.schedule.data.datasources.ApiService
import ru.education.building.schedule.data.repositories.ScheduleRepository
import ru.education.building.schedule.view.viewmodels.ScheduleViewModel


fun createHttpClient() = HttpClient {
    install(ContentNegotiation) { json(Json { ignoreUnknownKeys = true }) }
}

val appModule = module {
    single { createHttpClient() }
    single { ApiService(get()) }
    single { ScheduleRepository(get()) }
    viewModelOf(::ScheduleViewModel)  // <-- DSL для ViewModel
}
